import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

const getProgressColor = (percentage) => {
  if (percentage < 35) {
    return '#DC2626'; // Red
  }
  if (percentage < 50) {
    return '#D97706'; // Amber
  }
  if (percentage < 75) {
    return '#2E90FA'; // Neutral Blue
  }
  if (percentage < 90) {
    return '#22C55E'; // Light Green
  }
  return '#16A34A'; // Strong Green
};

const CompletionProgressBar = ({
  percentage = 0,
  label = 'Completion Rate',
  height = 6,
  showLabel = true,
  showPercentage = true,
  withContainer = false
}) => {
  const color = getProgressColor(percentage);

  const content = (
    <>
      {(showLabel || showPercentage) && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
          {showLabel && (
            <Typography variant="caption" color="text.secondary">
              {label}
            </Typography>
          )}
          {showPercentage && (
            <Typography variant="caption" sx={{ fontWeight: 600, color }}>
              {percentage}%
            </Typography>
          )}
        </Box>
      )}
      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          height,
          borderRadius: height / 2,
          backgroundColor: '#E5E7EB',
          '& .MuiLinearProgress-bar': {
            borderRadius: height / 2,
            backgroundColor: color,
          },
        }}
      />
    </>
  );

  if (withContainer) {
    return (
      <Box
        sx={{
          backgroundColor: '#F8FAFC',
          px: 1.5,
          py: 2,
          border: 'none',
          borderBottom: '1px solid',
          borderBottomColor: 'divider',
        }}
      >
        {content}
      </Box>
    );
  }

  return <Box>{content}</Box>;
};

export default CompletionProgressBar;
